<template>
  <div class="container">
    <h2 class="video-title">{{ videoTitle }}</h2>
    <div class="video-wrapper">
      <video 
        ref="videoPlayer" 
        controls
        class="video-player"
       
      >
        <source :src="videoSrc"  type="video/mp4">
        您的浏览器不支持视频播放。
      </video>
    </div>
  </div>
</template>

<script setup>

import {ref, watchEffect } from 'vue'; // 记得导入
import { useRoute } from 'vue-router'
const videoSrc = ref('');
const videoTitle =  ref('');
const route = useRoute() // 用于获取路由中参数
// 替换掉原来的 watch
watchEffect(() => {
  // 直接使用 route.query 来更新最终显示的数据
  videoTitle.value = route.query.title || '默认标题';
  videoSrc.value = route.query.videosrc || '';

});



</script>

<style scoped>
.container {
  padding: 20px;
  font-family: Arial, sans-serif;
  max-width: 100%;
  box-sizing: border-box;
}

.video-title {
  margin-bottom: 20px;
  color: #333;
  font-size: 1.5rem; /* 使用相对单位 */
  text-align: center;
}

.video-wrapper {
  width: 100%;
  max-width: 100%;
  position: relative;
}

.video-player {
  width: 100%;
  height: auto; /* 关键：让高度自适应 */
  max-width: 100%;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  object-fit: contain; /* 保持视频比例，避免变形[8](@ref) */
}

/* 移动端优先的响应式设计 */
@media (max-width: 768px) {
  .container {
    padding: 15px;
  }
  
  .video-title {
    font-size: 1.2rem;
    margin-bottom: 15px;
  }
  
  .video-player {
    border-radius: 4px;
  }
}

/* 平板和桌面端样式 */
@media (min-width: 769px) {
  .container {
    max-width: 500px; /* 限制最大宽度 */
    margin: 0 auto; /* 居中显示 */
  }
}

/* 大屏幕样式 */
@media (min-width: 1024px) {
  .container {
    max-width: 500px;
	margin: 0 auto; /* 水平居中 */
  }
}
</style>